import { render } from "./pageNotFound.vue?vue&type=template&id=1de0180c&ts=true"
import script from "./pageNotFound.vue?vue&type=script&lang=ts"
export * from "./pageNotFound.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__